export const ORDEN_MENUS_PRINCIPALES = [
  "DASHBOARD",
  "VENTAS",
  "INVENTARIO",
  "COMPRAS",
  "TRANSACCION",
  "RRHH",
  "ADMINISTRACION",
  "SOPORTE",
]

export const ORDEN_SUBMENUS = {
  VENTAS: ["VENTAS1", "VENTAS2", "VENTAS3", "VENTAS4", "VENTAS5", "VENTAS6", "VENTAS7", "VENTAS8", "VENTAS9", "VENTAS10", "VENTAS11", "VENTAS12"],
  INVENTARIO: ["INVENTARIO1", "INVENTARIO2", "INVENTARIO3", "INVENTARIO4", "INVENTARIO5"],
  COMPRAS: ["COMPRAS1", "COMPRAS2", "COMPRAS3", "COMPRAS4", "COMPRAS5"],
  TRANSACCION: ["TRANSACCIONES4", "TRANSACCIONES9", "TRANSACCIONES1", "TRANSACCIONES2", "TRANSACCIONES5", "TRANSACCIONES6", "TRANSACCIONES7", "TRANSACCIONES8", "TRANSACCIONES10", "TRANSACCIONES3"],
  RRHH: ["RRHH1", "RRHH2", "RRHH3", "RRHH4", "RRHH5", "RRHH6"],
  ADMINISTRACION: ["ADMINISTRACION1", "ADMINISTRACION2", "ADMINISTRACION3", "ADMINISTRACION4", "ADMINISTRACION5", "ADMINISTRACION6", "ADMINISTRACION7", "ADMINISTRACION8"],
  SOPORTE: ["SOPORTE1", "SOPORTE2", "SOPORTE3", "SOPORTE4", "SOPORTE5"],
}

const normalizarMenuId = (menuLike) => String(menuLike?.id || menuLike?.idMenuAcceso || "").trim()

const obtenerNumeroFinalMenu = (menuId) => {
  const numero = String(menuId || "").match(/\d+$/)?.[0]
  return numero ? parseInt(numero, 10) : 0
}

const normalizarBaseMenuId = (menuId) => {
  const idNormalizado = normalizarMenuId({ id: menuId })
  const base = idNormalizado.replace(/\d+$/, "")

  if (ORDEN_MENUS_PRINCIPALES.includes(base)) {
    return base
  }

  if (base.endsWith("ES")) {
    const singularES = base.slice(0, -2)
    if (ORDEN_MENUS_PRINCIPALES.includes(singularES)) {
      return singularES
    }
  }

  if (base.endsWith("S")) {
    const singularS = base.slice(0, -1)
    if (ORDEN_MENUS_PRINCIPALES.includes(singularS)) {
      return singularS
    }
  }

  return base
}

const compararConOrdenCustom = (idA, idB, menuPadre, ordenCustom = []) => {
  const ordenMap = new Map(ordenCustom.map((id, index) => [id, index + 1]))
  const ordenA = idA === menuPadre ? 0 : (ordenMap.get(idA) ?? 999)
  const ordenB = idB === menuPadre ? 0 : (ordenMap.get(idB) ?? 999)

  if (ordenA !== ordenB) {
    return ordenA - ordenB
  }

  const numeroA = obtenerNumeroFinalMenu(idA)
  const numeroB = obtenerNumeroFinalMenu(idB)

  if (numeroA !== numeroB) {
    return numeroA - numeroB
  }

  return idA.localeCompare(idB)
}

export const ordenarMenus = (menus = [], menuPadre = null) => {
  if (!Array.isArray(menus)) {
    return []
  }

  const copia = [...menus]

  if (menuPadre && ORDEN_SUBMENUS[menuPadre]) {
    return copia.sort((a, b) =>
      compararConOrdenCustom(normalizarMenuId(a), normalizarMenuId(b), menuPadre, ORDEN_SUBMENUS[menuPadre])
    )
  }

  const ordenMenusPrincipales = new Map(
    ORDEN_MENUS_PRINCIPALES.map((id, index) => [id, index]),
  )

  return copia.sort((a, b) => {
    const idA = normalizarMenuId(a)
    const idB = normalizarMenuId(b)
    const baseA = normalizarBaseMenuId(idA)
    const baseB = normalizarBaseMenuId(idB)
    const ordenBaseA = ordenMenusPrincipales.get(baseA) ?? 999
    const ordenBaseB = ordenMenusPrincipales.get(baseB) ?? 999

    if (ordenBaseA !== ordenBaseB) {
      return ordenBaseA - ordenBaseB
    }

    if (baseA === baseB && ORDEN_SUBMENUS[baseA]) {
      return compararConOrdenCustom(idA, idB, baseA, ORDEN_SUBMENUS[baseA])
    }

    const numeroA = obtenerNumeroFinalMenu(idA)
    const numeroB = obtenerNumeroFinalMenu(idB)

    if (numeroA !== numeroB) {
      return numeroA - numeroB
    }

    return idA.localeCompare(idB)
  })
}

export const ordenarEstructuraMenu = (menuStructure = []) =>
  ordenarMenus(menuStructure).map((menu) => ({
    ...menu,
    children: ordenarMenus(menu.children || [], menu.id),
  }))
